<template>
	<div class="ent-account-wrap">
		<!-- 顶部 Banner -->
		<div class="ent-banner">
			<div class="banner-inner">
				<div class="banner-icon">
					<i class="el-icon-office-building"></i>
				</div>
				<div class="banner-info">
					<h2>{{ cinfo.corporateName || cinfo.miniName || '企业名称未设置' }}</h2>
					<div class="banner-meta" v-if="cinfo.corporateLevel !== undefined || cinfo.endTime">
						<el-tag size="medium" effect="dark" :type="getLevelLinkType()">{{ getDisplayLevelName() }}</el-tag>
						<span class="meta-divider" v-if="(cinfo.corporateLevel == 1 || cinfo.corporateLevel == 2) && cinfo.endTime"></span>
						<span class="meta-expire" :class="{ 'meta-expire--urgent': isNearExpiry }" v-if="(cinfo.corporateLevel == 1 || cinfo.corporateLevel == 2) && cinfo.endTime">
							<i :class="isExpired ? 'el-icon-warning' : 'el-icon-time'"></i>
							{{ expiryStatusText }}
						</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 主内容 -->
		<div class="ent-body" v-loading="loading">
			<!-- 1. 基本信息 -->
			<div class="info-section">
				<div class="section-title">
					<i class="el-icon-s-custom"></i>
					<span>基本信息</span>
				</div>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :md="12">
						<div class="field-block">
							<div class="field-label"><i class="el-icon-office-building"></i> 企业名称</div>
							<div class="field-value">{{ form.companyName || '--' }}</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12">
						<div class="field-block">
							<div class="field-label"><i class="el-icon-postcard"></i> 统一社会信用代码</div>
							<div class="field-value code-text">{{ form.creditCode || '--' }}</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12">
						<div class="field-block">
							<div class="field-label"><i class="el-icon-map-location"></i> 注册地址</div>
							<div class="field-value">{{ form.address || '--' }}</div>
						</div>
					</el-col>
				</el-row>
			</div>

			<!-- 2. 证照资料 -->
			<div class="info-section">
				<div class="section-title">
					<i class="el-icon-document-copy"></i>
					<span>证照资料</span>
				</div>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :md="12">
						<div class="field-block">
							<div class="field-label"><i class="el-icon-document"></i> 企业营业执照复印件</div>
							<div class="field-value">
								<template v-if="form.businessLicense">
									<div class="file-item-view">
										<i class="el-icon-document"></i>
										<span>营业执照文件</span>
									</div>
								</template>
								<span v-else>--</span>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>

			<!-- 3. 联系人 -->
			<div class="info-section">
				<div class="section-title">
					<i class="el-icon-user"></i>
					<span>联系人</span>
				</div>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :md="12">
						<div class="field-block">
							<div class="field-label"><i class="el-icon-user"></i> 联系人姓名</div>
							<div class="field-value">{{ form.contactPerson || '--' }}</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12">
						<div class="field-block">
							<div class="field-label"><i class="el-icon-mobile-phone"></i> 联系人手机号码</div>
							<div class="field-value">{{ form.contactPhone || '--' }}</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { getMemberGetCorporateDetail } from '@/api/user/user';

	export default {
		name: 'Account',
		data() {
			return {
				loading: false,
				form: {
					companyName: '',
					address: '',
					creditCode: '',
					businessLicense: '',
					contactPerson: '',
					contactPhone: ''
				}
			};
		},
		created() {
			this.getMemberGetCorporateDetail();
		},
		computed: {
			...mapGetters('User', ['cinfo']),
			expiryDiffDays() {
				if (!this.cinfo.endTime) return null;
				const now = new Date();
				const endTime = new Date(this.cinfo.endTime);
				const diffTime = endTime - now;
				return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
			},
			isExpired() {
				return this.expiryDiffDays !== null && this.expiryDiffDays < 0;
			},
			isNearExpiry() {
				if (this.expiryDiffDays === null) return false;
				const d = this.expiryDiffDays;
				return d <= 30 && d >= -30;
			},
			expiryStatusText() {
				if (!this.cinfo.endTime) return '';
				const dateStr = this.cinfo.endTime.substring(0, 10);
				const d = this.expiryDiffDays;
				if (d === null) return dateStr;
				if (d < 0) return `${dateStr} 到期（已过期 ${Math.abs(d)} 天）`;
				if (d === 0) return `${dateStr} 到期（今日到期）`;
				if (d <= 30) return `${dateStr} 到期（剩余 ${d} 天）`;
				return `${dateStr} 到期`;
			}
		},
		methods: {
			getMemberGetCorporateDetail() {
				this.loading = true;
				getMemberGetCorporateDetail(this.cinfo.corporateId).then(res => {
					this.loading = false;
					if (res.code === 200) {
						const c = res.data;
						this.form = {
							companyName: c.corporateName || c.miniName || '',
							address: c.address || '',
							creditCode: c.creditCode || '',
							businessLicense: c.businessLicense || '',
							contactPerson: c.contactPerson || '',
							contactPhone: c.contactPhone || ''
						};
					}
				}).catch(() => {
					this.loading = false;
				});
			},

			getDisplayLevelName() {
				return this.cinfo.corporateLevel == 0 || !this.cinfo.corporateLevel ? '基础版' : this.cinfo.corporateLevel == 1 ? '专业版会员' : '旗舰版会员';
			},

			getLevelLinkType() {
				return this.cinfo.corporateLevel == 0 || !this.cinfo.corporateLevel ? 'info' : this.cinfo.corporateLevel == 1 ? 'primary' : 'warning';
			}
		}
	};
</script>

<style lang="less" scoped>
	.ent-account-wrap {
		background: #fff;
		border-radius: 12px;
		border: 1px solid #e2e8f0;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		min-height: calc(100vh - 120px);
		margin-left: 20px;
	}

	/* ========== Banner ========== */
	.ent-banner {
		position: relative;
		background: linear-gradient(135deg, #eff6ff, #e0e7ff);
		padding: 24px 32px;
		border-radius: 12px 12px 0 0;
		overflow: hidden;
	}

	.banner-inner {
		position: relative;
		display: flex;
		align-items: center;
		gap: 16px;
	}

	.banner-icon {
		flex-shrink: 0;
		width: 52px;
		height: 52px;
		background: rgba(21, 93, 252, 0.1);
		border-radius: 12px;
		display: flex;
		align-items: center;
		justify-content: center;

		i {
			font-size: 26px;
			color: #155dfc;
		}
	}

	.banner-info {
		h2 {
			margin: 0;
			font-size: 20px;
			font-weight: 700;
			color: #0f172a;
		}

		.banner-meta {
			display: flex;
			align-items: center;
			gap: 10px;
			margin-top: 8px;
		}

		.meta-divider {
			width: 1px;
			height: 18px;
			background: #cbd5e1;
			border-radius: 1px;
			flex-shrink: 0;
		}

		.meta-expire {
			display: inline-flex;
			align-items: center;
			gap: 4px;
			font-size: 13px;
			color: #64748b;

			i {
				font-size: 14px;
				color: #94a3b8;
			}

			&.meta-expire--urgent {
				color: #dc2626;
				font-weight: 600;

				i {
					color: #ef4444;
					animation: pulse-warn 1.5s ease-in-out infinite;
				}
			}
		}
	}

	@keyframes pulse-warn {
		0%,
		100% {
			opacity: 1;
		}
		50% {
			opacity: 0.5;
		}
	}

	/* ========== Body ========== */
	.ent-body {
		padding: 20px 24px;
		background: #f8fafc;
		border-bottom-left-radius: 12px;
		border-bottom-right-radius: 12px;
	}

	/* ========== Section Card ========== */
	.info-section {
		position: relative;
		background: #fff;
		border-radius: 10px;
		padding: 20px 24px 8px;
		margin-bottom: 16px;
		border: 1px solid #e2e8f0;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
	}

	.section-title {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 15px;
		font-weight: 600;
		color: #0f172a;
		margin-bottom: 18px;
		padding-bottom: 12px;
		border-bottom: 1px dashed #e2e8f0;

		i {
			font-size: 16px;
			color: #155dfc;
		}
	}

	/* ========== 字段展示 ========== */
	.field-block {
		margin-bottom: 20px;

		.field-label {
			font-size: 12px;
			color: #94a3b8;
			margin-bottom: 6px;
			display: flex;
			align-items: center;
			gap: 4px;

			i {
				color: #155dfc;
			}
		}

		.field-value {
			font-size: 14px;
			color: #0f172a;
			padding: 8px 12px;
			background: #f8fafc;
			border-radius: 6px;
			border: 1px solid #e2e8f0;
			min-height: 36px;
			line-height: 36px;
			word-break: break-all;
		}
	}

	/* ========== 文件展示 ========== */
	.file-item-view {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 8px 14px;
		background: #eff6ff;
		border: 1px solid #bfdbfe;
		border-radius: 6px;
		color: #155dfc;
		font-size: 13px;

		i {
			font-size: 16px;
		}
	}
</style>
